import { getOidcSettings } from '@/config/oidcSettings'
import { createStore } from 'vuex'
import { vuexOidcCreateStoreModule, VuexOidcState } from 'vuex-oidc'
import { OpenAPI } from '@itemis-solutions/platform-client-sdk'
import { useEnvStore } from '../envStore'
import { pinia } from '..'
import { watchEffect } from 'vue'

export const vuexStore = createStore({
  modules: {},
})

const envStore = useEnvStore(pinia)

export function setupOidcModule() {
  OpenAPI.BASE = envStore.variables.ANALYZE_PLATFORM_URL
  const settings = getOidcSettings(envStore.variables)
  try {
    const module = vuexOidcCreateStoreModule(settings, undefined, {
      userLoaded({ access_token }) {
        OpenAPI.TOKEN = access_token
      },
    })
    vuexStore.registerModule('oidcStore', module)
    watchEffect(() => {
      const token = (module.state as VuexOidcState).access_token
      if (token) {
        OpenAPI.TOKEN = token
      }
    })
  } catch (e) {
    console.error('Error setting up oidc', e)
  }
}
